<template>
	<!-- <div class="pb-2">
		<div class="text-sm text-black gradient flex py-4 md2:py-3 justify-between px-8 border md:flex-row flex-col md:space-x-4 space-y-3">
			<div class="w-8 md:block hidden" />
			<div class="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-4 items-center justify-center">
				<span class="bg-magnolia-300 px-3 py-2 md2:py-1 rounded-lg shadow-lg font-semibold text-center text-xs md:text-sm"> Shop Our Best Sellers! </span>
				<router-link class="underline hover:text-ihh-dark-salmon text-center text-xs md:text-sm" to="/categories/best-sellers-1/">
					Must-Have Items You’ll Love
				</router-link>
			</div>
			<button @click="hideBanner" class="w-8 md:block flex" type="button" title="Close">
				<div class="m-auto items-center flex w-full justify-end">
					<div class="rotate-45 absolute bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
					<div class="-rotate-45 bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
				</div>
			</button>
		</div>
	</div> -->
	<div class="pb-2 w-full">
		<div class="text-sm text-black gradient flex w-full justify-between px-4 py-3 md:px-8 xl:px-16">
			<!-- padding-left 12 is to compensate for the button with the w-8 and the px-4 on the parent div, allowing the banner text to be centered -->
			<div class="flex flex-grow flex-col pl-10 md:pl-8 md:flex-row space-y-3 md:space-y-0 md:space-x-4 items-center justify-center">
				<button class="bg-magnolia-300/85 px-3 py-2 md:py-1 rounded-lg shadow-lg font-semibold text-center text-xs md:text-sm">
					<router-link to="/categories/summer-favorites/">Summer Is Here ☀️</router-link>
				</button>
				<router-link class="hidden md:block underline hover:text-ihh-dark-salmon text-center text-xs md:text-sm" to="/categories/summer-favorites/">
					Shop Midwife & Mama Favorites
				</router-link>
			</div>
			<button @click="hideBanner" class="w-8 md:block flex" type="button" title="Close">
				<div class="m-auto items-center flex w-full justify-end">
					<div class="rotate-45 absolute bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
					<div class="-rotate-45 bg-ihh-slate-gray group-hover:bg-ihh-white py-[1px] px-2"></div>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Banner',
	emits: ['hide-banner'],
	data() {
		return {}
	},
	methods: {
		hideBanner() {
			this.$emit('hide-banner')
		},
	},
}
</script>

<style scoped></style>
